// src/utils/FilterContext.js
import React, { createContext, useState, useContext } from 'react';

const FilterContext = createContext();

// Категории из опций
const CATEGORIES = [
    "beaches",
    "hotel",
    "entertainment",
    "bank",
    "society",
    "food",
    "sport",
    // "bar",
    // "fastfood",
    // "restaurant",
    "shop",
    "education",
    "estate",
    "other",
    "panorama"
];

export const FilterProvider = ({ children }) => {
    const [activeFilters, setActiveFilters] = useState(
        CATEGORIES.reduce((acc, category) => {
            acc[category] = true;
            return acc;
        }, {})
    );

    const toggleFilter = (category) => {
        setActiveFilters(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    const resetFilters = () => {
        setActiveFilters(
            CATEGORIES.reduce((acc, category) => {
                acc[category] = true;
                return acc;
            }, {})
        );
    };

    // новый метод — включить только одну категорию
    const selectFilter = (category) => {
        setActiveFilters(
            CATEGORIES.reduce((acc, cat) => {
                acc[cat] = (cat === category);
                return acc;
            }, {})
        );
    };

    return (
        <FilterContext.Provider value={{
            CATEGORIES,
            activeFilters,
            toggleFilter,
            resetFilters,
            selectFilter
        }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilters = () => useContext(FilterContext);
